import { makeAutoObservable } from 'mobx';

export default class Message {
  tip = '';
  mcSet = new Set();
  messageModalVisible = false;

  noticeId = '';

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  addMcIntoSet(mc: string) {
    this.mcSet.add(mc);
  }

  clearMcSet() {
    this.mcSet.clear();
  }

  setMessage(msg: string) {
    this.tip = msg || 'message.rejected';
  }

  setMessageModalVisible(visible: boolean) {
    this.messageModalVisible = visible;
  }

  setnoticeId(noticeId: string) {
    this.noticeId = noticeId || '';
  }
}